import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, GuardResult } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { UserService } from '../http-services/common/user.service';
import { UserRoleEnum } from '@app/shared/helpers/role-based-access.helper';
 
@Injectable({
  providedIn: 'root'
})
export class RoleGuard {

  private readonly defaultExpectedRoles: UserRoleEnum[] = [UserRoleEnum.Developer, UserRoleEnum.Planner];
 
  constructor(
    public msalService:MsalService,
    private readonly userService:UserService) { }
 
  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<GuardResult> {

      let expectedRoles = next.data["expectedRoles"];
      if(!expectedRoles) {
        expectedRoles = this.defaultExpectedRoles;
      }

      await this.msalService.instance.initialize();
      const activeAccount = this.msalService.instance.getActiveAccount();
      if(!activeAccount){
         return false;
      }
 
      const user = await this.userService.getUser();
 
      for(let role of expectedRoles) {
        if(role == UserRoleEnum.Developer && user.isDeveloper) {
          return true;
        }
 
        if(role == UserRoleEnum.Planner && user.isPlanner) {
          return true;
        }
 
        if(role == UserRoleEnum.Operator && user.isOperator) {
          return true;
        }

        if(role == UserRoleEnum.CrossTenantAdmin && user.isCrossTenantAdmin) {
          return true;
        }

        if(role == UserRoleEnum.SingleTenantAdmin && user.isSingleTenantAdmin) {
          return true;
        }
      }
 
      return false;
  }
}